/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_items"] }] */
import imm from 'object-path-immutable';
import { hasOwnProperties } from '@keypr/redux-json-api/lib/utils';
import equal from 'deep-equal';

const stateContainsResource = (state, resource, type) => {
  const updatePath = [type, '_items'];

  if (hasOwnProperties(state, updatePath)) {
    return state[type]._items.findIndex(
      item => item._id === resource._id,
    ) > -1;
  }

  return false;
};

export const updateOrInsertResource = type => (state, resource) => {
  if (typeof resource !== 'object') {
    return state;
  }

  let newState = state;
  const updatePath = [type, '_items'];

  if (stateContainsResource(state, resource, type)) {
    const resources = state[type]._items;
    const idx = resources.findIndex(item => item._id === resource._id);

    if (!equal(resources[idx], resource)) {
      newState = imm.assign(newState, updatePath.concat(idx), resource);
    }
  } else {
    newState = imm.push(newState, updatePath, resource);
  }

  return newState;
};

export const removeResourceFromState = (state, resource, type) => {
  const index = state[type]._items.findIndex(e => e._id === resource._id);
  const path = [type, '_items', index];

  return imm(state).del(path);
};

export const updateOrInsertResourcesIntoState = (state, resources, type) => {
  if (resources.length > 0) {
    return resources.reduce(updateOrInsertResource(type), state);
  }
  const newState = Object.assign({}, state);
  newState[type] = {
    _items: [],
  };
  return newState;
};

export const setIsInvalidatingForExistingResource = (state, { type, _id }, value = null) => {
  const idx = state[type]._items.findIndex(e => e._id === _id && e.type === type);
  const updatePath = [type, '_items', idx, 'isInvalidating'];

  return value === null
    ? imm(state).del(updatePath)
    : imm(state).set(updatePath, value);
};

export const ensureResourceTypeInState = (state, type) => {
  const path = [type, '_items'];
  return hasOwnProperties(state, [type])
    ? state
    : imm(state).set(path, []).value();
};



// WEBPACK FOOTER //
// ./src/utils/state-mutation-ticket.js